import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import ModuleHeader from "./ModuleHeader";
import HexBg from "@/assets/img/lcg/real-time-bg.webp";
import ReactQRCode from "react-qr-code";
// 弹窗固定宽高 + 偏移量
const POPUP_WIDTH = 212;
const POPUP_HEIGHT = 244;
const OFFSET = 15;
const RealTimeInventory = ({ className = "", }) => {
    const [inventoryData, setInventoryData] = useState([]);
    const scrollContainerRef = useRef(null);
    const scrollSpeed = 1;
    const scrollPause = 3000;
    // 二维码弹窗状态
    const [showQrPopup, setShowQrPopup] = useState(false);
    const [currentCode, setCurrentCode] = useState("");
    const [popupPos, setPopupPos] = useState({ x: 0, y: 0 });
    const [isScrollPaused, setIsScrollPaused] = useState(false);
    // 二维码鼠标移入：默认左侧弹出，边界防遮挡
    const handleQrMouseEnter = (e, code) => {
        const mouseX = e.clientX;
        const mouseY = e.clientY;
        setCurrentCode(code);
        let left = mouseX - POPUP_WIDTH - OFFSET;
        if (left < 10) {
            left = mouseX + OFFSET;
        }
        left = Math.max(10, Math.min(left, window.innerWidth - POPUP_WIDTH - 10));
        let top = mouseY + OFFSET;
        if (top + POPUP_HEIGHT > window.innerHeight - 10) {
            top = mouseY - POPUP_HEIGHT - OFFSET;
        }
        top = Math.max(10, top);
        setPopupPos({ x: left, y: top });
        setShowQrPopup(true);
        setIsScrollPaused(true);
    };
    // 二维码鼠标移出
    const handleQrMouseLeave = () => {
        setShowQrPopup(false);
        setIsScrollPaused(false);
    };
    // 初始化时强制刷新布局（解决宽度计算延迟）
    useEffect(() => {
        getData();
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollLeft = 0;
            // 强制重绘
            scrollContainerRef.current.style.display = "none";
            setTimeout(() => {
                scrollContainerRef.current?.style.setProperty("display", "block", "important");
            }, 0);
        }
    }, []);
    // 滚动逻辑
    useEffect(() => {
        if (!scrollContainerRef.current)
            return;
        const container = scrollContainerRef.current;
        let animationFrameId;
        let lastScrollTime = 0;
        let isPaused = false;
        const scroll = (timestamp) => {
            if (timestamp - lastScrollTime < 30) {
                animationFrameId = requestAnimationFrame(scroll);
                return;
            }
            lastScrollTime = timestamp;
            // 鼠标悬浮卡片 || 二维码弹窗打开时暂停滚动
            if (!isPaused && !container.isPaused && !isScrollPaused) {
                container.scrollLeft += scrollSpeed;
                const maxScroll = container.scrollWidth - container.clientWidth;
                if (maxScroll > 0 && container.scrollLeft >= maxScroll - 5) {
                    isPaused = true;
                    setTimeout(() => ((container.scrollLeft = 0), (isPaused = false)), scrollPause);
                }
            }
            animationFrameId = requestAnimationFrame(scroll);
        };
        animationFrameId = requestAnimationFrame(scroll);
        return () => cancelAnimationFrame(animationFrameId);
    }, [isScrollPaused]);
    /**
     * @description: getData - 获取数据
     */
    const getData = async () => {
        try {
            // const res = await lcgApi.realInventory();
            //setInventoryData(res.data as any);
            setInventoryData([
                {
                    id: "1969659468900958209",
                    mname: "加湿器",
                    spec: "得力",
                    mtype: 2,
                    mtypeName: "耗材",
                    cid: "1955845218998517762",
                    cname: "加湿器",
                    mdeptId: "111",
                    mdeptName: "综合管理部",
                    sid: "1",
                    sname: "中心库",
                    unit: "件",
                    qty: 36,
                    amount: 5000,
                    availQty: 36,
                    availAmount: 5000,
                },
                {
                    id: "1969659468452167681",
                    mname: "显示器",
                    spec: "华为",
                    mtype: 2,
                    mtypeName: "耗材",
                    cid: "1955845220315529218",
                    cname: "显示器",
                    mdeptId: "111",
                    mdeptName: "综合管理部",
                    sid: "1",
                    sname: "中心库",
                    unit: "件",
                    qty: 121,
                    amount: 19000,
                    availQty: 121,
                    availAmount: 19000,
                },
                {
                    id: "1969659490086387714",
                    mname: "净化器",
                    spec: "白雪",
                    mtype: 2,
                    mtypeName: "耗材",
                    cid: "1955845214829379585",
                    cname: "净化器",
                    mdeptId: "111",
                    mdeptName: "综合管理部",
                    sid: "1",
                    sname: "中心库",
                    unit: "组",
                    qty: 39,
                    amount: 1875,
                    availQty: 39,
                    availAmount: 1875,
                },
                {
                    id: "1969659490254159873",
                    mname: "办公桌",
                    spec: "得力",
                    mtype: 2,
                    mtypeName: "耗材",
                    cid: "1955845216792313857",
                    cname: "办公桌",
                    mdeptId: "111",
                    mdeptName: "综合管理部",
                    sid: "1",
                    sname: "中心库",
                    unit: "个",
                    qty: 292,
                    amount: 5000,
                    availQty: 292,
                    availAmount: 5000,
                },
                {
                    id: "1969699958954467329",
                    mname: "饮水机",
                    spec: "美的",
                    mtype: 1,
                    mtypeName: "低耗品",
                    cid: "1955844970951573506",
                    cname: "饮用水加热器具",
                    mdeptId: "111",
                    mdeptName: "综合管理部",
                    sid: "1",
                    sname: "中心库",
                    unit: "台",
                    qty: 16,
                    amount: 80000,
                    availQty: 16,
                    availAmount: 80000,
                },
                {
                    id: "1969699950595219457",
                    mname: "多功能一体机",
                    spec: "惠普",
                    mtype: 1,
                    mtypeName: "低耗品",
                    cid: "1955845028077993985",
                    cname: "多功能一体机",
                    mdeptId: "111",
                    mdeptName: "综合管理部",
                    sid: "1",
                    sname: "中心库",
                    unit: "台",
                    qty: 113,
                    amount: 22500,
                    availQty: 113,
                    availAmount: 22500,
                },
                {
                    id: "1969699950595219457",
                    mname: "电子办公本",
                    spec: "惠普",
                    mtype: 1,
                    mtypeName: "低耗品",
                    cid: "1955845028077993985",
                    cname: "电子办公本",
                    mdeptId: "111",
                    mdeptName: "综合管理部",
                    sid: "1",
                    sname: "中心库",
                    unit: "台",
                    qty: 28,
                    amount: 22500,
                    availQty: 28,
                    availAmount: 22500,
                },
            ]);
        }
        catch (error) {
            console.error("获取部门数据失败:", error);
        }
    };
    return (_jsxs("div", { className: `
        relative
        bg-gradient-to-t
        from-[rgba(7,31,75,0.5)]
        to-[rgba(6,32,66,0.2)]
        flex flex-col
        ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u5B9E\u65F6\u63A8\u9001", isLong: true }), _jsx("div", { className: "flex-1 flex items-center py-[0.3rem] min-w-0 min-h-0", children: _jsx("div", { ref: scrollContainerRef, className: "overflow-x-auto scrollbar-hide w-full", style: {
                        maxWidth: "100%",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                        padding: 0,
                        margin: 0,
                    }, onMouseEnter: () => (scrollContainerRef.current.isPaused = true), onMouseLeave: () => (scrollContainerRef.current.isPaused = false), children: _jsx("div", { className: "flex gap-[0.34rem] py-[0.1rem]", style: { margin: "0 auto" }, children: Array.isArray(inventoryData) &&
                            inventoryData.map((item, index) => (_jsxs("div", { className: "flex flex-col items-center flex-shrink-0", style: {
                                    width: "1.5rem",
                                    padding: 0,
                                    margin: 0,
                                }, children: [_jsxs("div", { className: "relative w-[1.99rem] h-[1.43rem]", children: [_jsx("div", { style: {
                                                    width: "100%",
                                                    height: "100%",
                                                    background: `url(${HexBg}) no-repeat center / contain`,
                                                } }), _jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: _jsx("div", { className: "text-[0.5rem] font-bold text-transparent bg-clip-text bg-gradient-to-t from-cyan-300 to-blue-200", style: { marginBottom: "0.2rem" }, children: item.qty }) })] }), _jsx("div", { className: "text-white text-center text-[0.18rem] w-full overflow-hidden", children: _jsxs("div", { className: "whitespace-nowrap overflow-hidden text-ellipsis px-[0.2rem] flex flex-col items-center", children: [item.cname, _jsx("div", { style: { cursor: "pointer" }, onMouseEnter: (e) => handleQrMouseEnter(e, item.cname), onMouseLeave: handleQrMouseLeave, children: _jsx(ReactQRCode, { value: item.cname, size: 24, fgColor: "#00ffff", bgColor: "transparent" }) })] }) })] }, item.id || index))) }) }) }), showQrPopup && (_jsxs("div", { style: {
                    position: "fixed",
                    left: popupPos.x,
                    top: popupPos.y,
                    width: POPUP_WIDTH,
                    background: "rgba(6, 42, 88, 0.95)",
                    padding: "16px",
                    borderRadius: "6px",
                    boxShadow: "0 0 12px rgba(0,255,255,0.3)",
                    zIndex: 9999,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "12px",
                    pointerEvents: "none",
                }, children: [_jsx(ReactQRCode, { value: currentCode, size: 180, fgColor: "#00ffff", bgColor: "transparent" }), _jsx("span", { style: { color: "#fff", fontSize: "16px" }, children: currentCode })] })), _jsx("style", { children: `
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      ` })] }));
};
export default RealTimeInventory;
